import React from 'react'
import { useStoryReader } from '@hooks/book/useStoryReader'
import { BookPromotionAcceptProps, BookPromotionProps } from './interface'

export function withBookPromotion(Component: React.FC<BookPromotionProps>) {
  function WithBookPromotion({ isDrawer = false }: BookPromotionAcceptProps) {
    const { bookPromotionSales: data } = useStoryReader()
    const newProps = {
      data,
      isDrawer,
    }

    return <Component {...newProps} />
  }

  return WithBookPromotion
}
